// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import { LearningObjective, MarkValue, ReportCardSection } from "../../../Utilities";

export type Base = {
	learningObjectiveID: LearningObjective["id"] | null;
	markValueID: MarkValue["id"] | null;
	reportCardSectionID: ReportCardSection["id"] | null;
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, "learningObjectiveID" | "reportCardSectionID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	learningObjectiveID: null,
	markValueID: null,
	reportCardSectionID: null,
};

export type Detail = Base;

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export type CreateInReportCardSection = Omit<Create, "reportCardSectionID">;

export type CreateInReportCardSectionRequiredKey = Exclude<CreateRequiredKey, "reportCardSectionID">;

export type CreateInReportCardSectionSubset<
	K extends keyof CreateInReportCardSection = keyof CreateInReportCardSection,
> = Pick<CreateInReportCardSection, CreateInReportCardSectionRequiredKey | K>;

export const blankItemInReportCardSection: CreateInReportCardSection = omitKeys(initialCreate, ["reportCardSectionID"]);
